import React, {useContext, useState} from 'react';
import {PlayerContext} from '../../PlayerContext';
import IconButton from '@mui/material/IconButton';
import { Close } from '@mui/icons-material';
import { analyticsManager } from '../../..';
import LineBreak from '../../../maker/component/LineBreak';
import { browserLocales, checkMobile, printObj, addOpacityToHexColor } from '../../Utils';
import { useTranslation } from 'react-i18next';
import { getMenuFontStyle, getMenuDescFontStyle } from '../../menuFontLoader';
import { StickerContext } from '../../StickerContext';
import './../../Player.css';
import { useMediaQuery } from 'react-responsive';

function MealDetail(props){
    const { t } = useTranslation();
    const storyDimensions = useContext(PlayerContext).get("storyDimensions");
    const playMode = useContext(PlayerContext).get("playMode");
    const sizeMultiplier = useContext(PlayerContext).get("sizeMultiplier"); 
    const menuOuterMargin = checkMobile() ? 8 * sizeMultiplier : 0;
    const closeColor = props.closeMenuColor;
    const navButtonStyle = {
        width: 40 * sizeMultiplier,
        height: 40 * sizeMultiplier,
        backgroundColor: addOpacityToHexColor(closeColor, 0.9),
        border: `1px solid ${addOpacityToHexColor("#ffffff", 0.35)}`,
    };
    const navIconSize = 24 * sizeMultiplier;
    const language = browserLocales(true)[0] === "en" ? "en" : "fr";
    const getLocalizedMenuText = (value) => {
        if (value == null) {
            return "";
        }
        if (typeof value === "string") {
            return value;
        }
        return value[language] ?? value.fr ?? value.en ?? "";
    };
    const getLocalizedMenuPrices = (value) => {
        if (value == null) {
            return null;
        }
        if (Array.isArray(value)) {
            return value;
        }
        return value[language] ?? value.fr ?? value.en ?? null;
    };
    const stickerContext = useContext(StickerContext);
    const textFontStyle = getMenuFontStyle(
        props.displayTextFont ?? (props.story.menuStyle === "custom" ? stickerContext.get("menuTextFont") : null),
        props.displayTextFallback ?? (props.story.menuStyle === "custom" ? stickerContext.get("menuTextFontFallback") : false),
    );
    const descFontStyle = getMenuDescFontStyle({
        descFont: props.displayDescFont ?? (props.story.menuStyle === "custom" ? stickerContext.get("menuDescFont") : null),
        descFontNameFromMenu: props.story.menuStyle === "custom" && props.menu?.descFont?.name ? props.menu.descFont.name : null,
        descFontFallback: props.displayDescFallback ?? (props.story.menuStyle === "custom" ? stickerContext.get("menuDescFontFallback") : false),
        textFontStyle,
    });
    const textFontBoldStyle = props.story.menuStyle === "custom" && props.menu?.textFontBold ? { fontWeight: "bold" } : {};
    const parsedTextFontSize = props.story.menuStyle === "custom" && props.menu?.textFontSize != null && props.menu.textFontSize !== ""
        ? Number(props.menu.textFontSize)
        : NaN;
    const entryTitleFontSizePx = (Number.isFinite(parsedTextFontSize) && parsedTextFontSize > 0 ? parsedTextFontSize : 18) * sizeMultiplier;
    const textColorStyle = {};
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });

    if (props.menu && props.story.menuStyle === "custom" && props.menu.textColor){
        textColorStyle.color = props.menu.textColor;
    }
    if (props.menu && props.story.menuStyle === "custom" && props.menu.detailTextColor){
        textColorStyle.color = props.menu.detailTextColor;
    }
    const priceColorStyle = {};
    if (props.menu && props.story.menuStyle === "custom" && props.menu.priceColor){
        priceColorStyle.color = props.menu.priceColor;
    }
    if (props.menu && props.story.menuStyle === "custom" && props.menu.detailPriceColor){
        priceColorStyle.color = props.menu.detailPriceColor;
    } 
    const descColorStyle = {};
    if (props.menu && props.story.menuStyle === "custom" && props.menu.descColor){
        descColorStyle.color = props.menu.descColor;
    }
    if (props.menu && props.story.menuStyle === "custom" && props.menu.detailDescColor){
        descColorStyle.color = props.menu.detailDescColor;
    } 
    
    const localizedNutritionalValue = props.pageEntry ? getLocalizedMenuText(props.pageEntry.nutritionalValue) : "";
    const nutrients = localizedNutritionalValue ? localizedNutritionalValue.split("-") : null;
    
    function formatDescription(){
        const localizedSubtitle = getLocalizedMenuText(props.pageEntry.entrySubtitle);
        if (!localizedSubtitle) return;

        const descriptionChunks = localizedSubtitle.split("<br>");

        const formattedDescription = descriptionChunks.map((chunk)=>{
            const idx = descriptionChunks.indexOf(chunk);
            if (idx > 0 && idx < descriptionChunks.length){ 
                return (<><br/><i>{chunk.trim()}</i></>);
            }
            else
                return chunk.trim();
        });

        return formattedDescription;
    }

    if (props.pageEntry != null){
        let additionalStyle = {};
        if (props.menu && props.story.menuStyle === "custom" && props.menu.backgroundColor){
            additionalStyle.backgroundColor = props.menu.backgroundColor;
        }
        if (props.menu && props.story.menuStyle === "custom" && props.menu.detailBackgroundColor){
            additionalStyle.backgroundColor = props.menu.detailBackgroundColor;
        }    
        if (props.fromMenuEditor){
            additionalStyle.top = 0;
            additionalStyle.left = 0;
        }    

        return (
            <>
                <div className={"menu-detail-container" + ((checkMobile() || playMode === "demo") ? ' menu-detail-container-scroll-mobile' : ' menu-detail-container-scroll-desktop')} style={{position: 'absolute', zIndex: 30, width: '100%', height: '100%', background: '#FFFFFF', display: 'flex', flexDirection: 'column', ...additionalStyle}} onClick={(e)=>e.stopPropagation()} onTouchStart={(e)=>e.stopPropagation()} onTouchEnd={(e)=>e.stopPropagation()}>
                    {playMode === "preview" && !isTabletOrMobile && <div style={{width: 1, height: storyDimensions.containerHeight * 0.6, backgroundColor: '#b2ede7', position: 'absolute', left: 0, bottom: 0}} />}                
                    <img src={props.pageEntry.entryImage} alt={getLocalizedMenuText(props.pageEntry.entryTitle) || "dish"} draggable={false} style={{width: '100%', height: storyDimensions.containerHeight * 0.4, objectFit: 'cover', pointerEvents: 'none', userSelect: 'none', WebkitUserSelect: 'none', WebkitUserDrag: 'none'}}/>
                    <div style={{padding: 16 * sizeMultiplier}}>
                        <div style={{fontSize: entryTitleFontSizePx, color: '#404040', ...textFontStyle, ...textColorStyle, ...textFontBoldStyle}}>{getLocalizedMenuText(props.pageEntry.entryTitle)}</div>
                        <LineBreak/>
                        <div style={{whiteSpace: 'pre-line', textAlign: 'start', fontSize: 14 * sizeMultiplier, fontStyle: 'italic', color: '#707070', ...descFontStyle, ...descColorStyle}}>{props.pageEntry.entrySubtitle && formatDescription()}</div>
                        <LineBreak/>
                        <div style={{textAlign: 'end', fontSize: 14 * sizeMultiplier, fontStyle: 'italic', color: '#707070', ...textFontStyle, ...priceColorStyle}}>
                            {(() => {
                                const prices = getLocalizedMenuPrices(props.pageEntry.entryPrice);
                                if (!prices) {
                                    return null;
                                }
                                return Array.isArray(prices) ? prices.join(" - ") : prices;
                            })()}
                        </div>                    
                        {props.pageEntry.allergens && 
                        <>
                            <LineBreak/>
                            <LineBreak/>
                            <LineBreak/>
                            <div style={{fontSize: 14 * sizeMultiplier, color: '#404040', fontStyle: 'italic', ...descFontStyle, ...textColorStyle}}>{t('AllergensLabel') + props.pageEntry.allergens.split(',').map((allergen)=> {return t(allergen.trim());}).join(" - ")}</div>
                        </>}
                        {nutrients && nutrients.length >= 5 && 
                        <>
                            <LineBreak/>
                            <LineBreak/>
                            <LineBreak/>
                            <div style={{color: '#404040', ...textFontStyle, ...textColorStyle}}>{t('Nutrients')}</div> 
                            <LineBreak/>                       
                            <div style={{display: 'flex', flexDirection: "row", width: '100%', justifyContent: 'space-evenly'}}>                            
                                <div className='circle' style={{background: "#dff44f"}}>
                                    <div className='nutrients-text' style={{...textFontStyle}}>
                                        {nutrients[0].trim()}
                                    </div>
                                </div>
                                <div className='circle' style={{background: "#abfb78"}}>
                                    <div className='nutrients-text' style={{...textFontStyle}}>
                                        {nutrients[1].trim()}
                                    </div>
                                </div>
                                <div className='circle' style={{background: "#b5ffdc"}}>
                                    <div className='nutrients-text' style={{...textFontStyle}}>
                                        {nutrients[2].trim()}
                                    </div>
                                </div>    
                            </div>                          
                            <div style={{marginTop: 10, display: 'flex', flexDirection: "row", width: '100%', justifyContent: 'space-evenly'}}>
                                <div className='circle' style={{background: "#caa593"}}>
                                    <div className='nutrients-text' style={{...textFontStyle}}>
                                        {nutrients[3].trim()}
                                    </div>
                                </div>
                                <div className='circle' style={{background: "#bae9b3"}}>
                                    <div className='nutrients-text' style={{...textFontStyle}}>
                                        {nutrients[4].trim()}
                                    </div>                               
                                </div>                       
                            </div>
                        </>}
                    </div>                           
                </div>
                <div style={{position: 'absolute', zIndex: 30, pointerEvents: "auto", top: storyDimensions.containerHeight - 40 * sizeMultiplier - 14 * sizeMultiplier - menuOuterMargin, left: storyDimensions.containerWidth - 2 * menuOuterMargin - 48 * sizeMultiplier }}>
                    <IconButton aria-label="close meal detail" style={navButtonStyle} onClick={(e) => props.close(e)}>
                        <Close style={{color: "#ffffff", width: navIconSize, height: navIconSize}}/>
                    </IconButton>
                </div> 
            </>
        );
    }
    else return null;
}

export default MealDetail;